"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = dictateState;

var _DictateState = require("../constants/DictateState");

var _setDictateState = require("../actions/setDictateState");

var _startDictate = require("../actions/startDictate");

var _stopDictate = require("../actions/stopDictate");

var DEFAULT_STATE = _DictateState.IDLE;

function dictateState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case _setDictateState.SET_DICTATE_STATE:
      state = payload.dictateState;
      break;

    case _startDictate.START_DICTATE:
      if (state === _DictateState.IDLE || state === _DictateState.STOPPING || state === _DictateState.WILL_START) {
        state = _DictateState.STARTING;
      }

      break;

    case _stopDictate.STOP_DICTATE:
      if (state === _DictateState.STARTING || state === _DictateState.DICTATING) {
        state = _DictateState.STOPPING;
      } else if (state === _DictateState.WILL_START) {
        state = _DictateState.IDLE;
      }

      break;

    default:
      break;
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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